"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = dictateState;

var _DictateState = require("../constants/DictateState");

var _setDictateState = require("../actions/setDictateState");

var _startDictate = require("../actions/startDictate");

var _stopDictate = require("../actions/stopDictate");

var DEFAULT_STATE = _DictateState.IDLE;

function dictateState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case _setDictateState.SET_DICTATE_STATE:
      state = payload.dictateState;
      break;

    case _startDictate.START_DICTATE:
      if (state === _DictateState.IDLE || state === _DictateState.STOPPING || state === _DictateState.WILL_START) {
        state = _DictateState.STARTING;
      }

      break;

    case _stopDictate.STOP_DICTATE:
      if (state === _DictateState.STARTING || state === _DictateState.DICTATING) {
        state = _DictateState.STOPPING;
      } else if (state === _DictateState.WILL_START) {
        state = _DictateState.IDLE;
      }

      break;

    default:
      break;
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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